import { withInstall, SFCWithInstall } from '@touchvue/utils'
import Calendar from './src/calendar.vue'

export const ToCalendar: SFCWithInstall<typeof Calendar> = withInstall(Calendar)

export * from './src/instance'
